import style from "../../../styles/navbar.module.css";
import styles from "../../../styles/menu.module.css";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
// import {Link as ScrollLink } from 'react-scroll';
const Menu = () => {
  const [innermenu, setinnermenuactive] = useState(false);
  const [menuactive, setmenuactive] = useState(false);
  const location = useLocation();
  function handlemenu() {
    setmenuactive(!menuactive);
  }

  function handleinnermenu() {
    setinnermenuactive(!innermenu);
  }

  useEffect(() => {
    if (menuactive === true) {
      document.documentElement.style.overflowY = "hidden";
    } else {
      document.documentElement.style.overflowY = "scroll";
    }
  }, [menuactive]);

  useEffect(() => {
    setmenuactive(false);
  }, [location]);

  return (
    <div className={styles.menucomponent}>
      <div className={style.menuwrapper} onClick={handlemenu}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="icon icon-tabler icons-tabler-outline icon-tabler-menu-2"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M4 6l16 0" />
          <path d="M4 12l16 0" />
          <path d="M4 18l16 0" />
        </svg>
      </div>
      <div
        className={menuactive ? styles.underlayactive : styles.underlayinactive}
        onClick={handlemenu}
      ></div>

      <div className={menuactive ? styles.sidemenuactive : styles.sidemenu}>
        <div className={styles.menutoggleoff} onClick={handlemenu}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-x"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M18 6l-12 12" />
            <path d="M6 6l12 12" />
          </svg>
        </div>

        <ul className={styles.navigations}>
          <Link to="/" className={styles.navlink}>
            {" "}
            <li className={styles.navlink}>HOME</li>
          </Link>
          <li className={styles.navlink} onClick={handleinnermenu}>
            <div className={styles.innerwrapper}>
              {" "}
              ACADEMICS{" "}
              <svg
                className={innermenu ? styles.expand : styles.collapse}
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="icon icon-tabler icons-tabler-outline icon-tabler-chevron-compact-down"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M4 11l8 3l8 -3" />
              </svg>
            </div>
            <ul
              className={
                innermenu ? styles.innermenuactive : styles.innermenuinactive
              }
            >
              <Link className={styles.innerlink} to="/blogs">
                {" "}
                <li className={styles.academiclink}>NEWS</li>
              </Link>
              <Link className={styles.innerlink} to="/calender">
                {" "}
                <li className={styles.academiclink}>CALENDER</li>
              </Link>
              <Link className={styles.innerlink} to="/teachers">
                {" "}
                <li className={styles.academiclink}>CONTACT TEACHER</li>
              </Link>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Menu;
